import { type MessageInstance } from "antd/es/message/interface";
import { type NavigateFunction } from "react-router-dom";

import { privateAPI, publicAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { setAuthLoading, setInitialize, setLogout, store } from "../index";
import type { LoginCredentials } from "../interfaces/auth";

export const userLogin = async (
  credentials: LoginCredentials,
  notify: MessageInstance,
) => {
  try {
    const response = await publicAPI.post("/auth/login", credentials);
    if (response.data) {
      const data = {
        token: response.data.accessToken,
        user: {
          id: response.data.id,
          fullName: response.data.fullName,
          email: response.data.email,
        },
      };
      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.user.id);
      store.dispatch(setInitialize({ token: data.token, user: data.user }));
      return { token: data.token, user: data.user };
    }
  } catch (error) {
    console.error("Login Error:", error);
    errorHandler(error, notify);
  }
};

export const loadUser = async () => {
  try {
    store.dispatch(setAuthLoading(true));
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const response = await privateAPI.get(`/user/${userId}`);
    store.dispatch(setInitialize({ token: token, user: response?.data }));
    return response?.data;
  } catch (error) {
    localStorage.clear();
    console.error("Get User Error:", error);
  }
};

export const logout = async (navigate: NavigateFunction) => {
  const token = localStorage.getItem("token");

  if (token) {
    try {
      // await privateAPI.post("/endpoint");
      store.dispatch(setLogout());
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  }
};
